import React, { useEffect, useState } from "react";
import { Col, Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import "./PaymentStatusTemplate.scss";
import { PaymentEventTypes } from "../../../utils/constants/events-types";
import EventDispatcher from "../../../utils/event-dispatcher";
import usePaymentRedirect from "../../../hooks/usePaymentRedirect";
import { ROUTES } from "../../../utils/constants";
import PrimaryActionButton from "../../Buttons/PrimaryActionButton/PrimaryActionButton";

export enum PaymentStatusType {
  LOADING = "loading",
  DONE = "done",
}

interface PaymentStatusTemplateProps {
  title: string;
  type?: PaymentStatusType;
  message?: string;
  eventType?: PaymentEventTypes;
  navigateUrl?: string;
  icon?: JSX.Element;
}

function PaymentStatusTemplate({
  type,
  title,
  message = "",
  eventType,
  navigateUrl = ROUTES.ROOT.DASHBOARD,
  icon,
}: PaymentStatusTemplateProps) {
  const { t } = useTranslation("wallet");
  const { handlePaymentRedirect } = usePaymentRedirect();
  const [showContinueBtn, setShowContinueBtn] = useState<boolean>(false);

  const handleContinue = () => {
    if (eventType) {
      EventDispatcher.dispatch(eventType, { message: message || title });
      handlePaymentRedirect(navigateUrl);
    }
    return;
  };

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    if (!showContinueBtn) {
      timeoutId = setTimeout(() => setShowContinueBtn(true), 5000);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [showContinueBtn]);

  return (
    <Col className="d-flex flex-column text-center justify-content-center px-3 align-items-center Grotesk PaymentStatusTemplate">
      <Stack
        gap={4}
        className="text-center justify-content-center align-items-center"
      >
        {icon && <div>{icon}</div>}
        <div>
          <p className="text-center PaymentStatusTitle">{title}</p>
          {message && (
            <p className="mt-3 text-center PaymentStatusMessage">{message}</p>
          )}
        </div>
      </Stack>

      {type === PaymentStatusType.DONE && (
        <Stack className="CtaSection">
          <p className="RedirectMessage">
            {t("you_will_be_redirected_shortly")}
          </p>
          {showContinueBtn && (
            <PrimaryActionButton
              size="lg"
              text={t("common:continue")}
              onClick={handleContinue}
            />
          )}
        </Stack>
      )}
    </Col>
  );
}

export default PaymentStatusTemplate;
